import { createFeature, createReducer, on } from '@ngrx/store';
import * as actions from './rfr-mon-save.actions';
import * as luxon from 'luxon';
import { State } from './rfr-mon-save.state';

export const initialState: State = {
  error: null,
  loaded: false,
  loading: false,
  data: [],
  receivedTime: null,
};

export default createFeature({
  name: 'rfrMonSave',
  reducer: createReducer(
  initialState,
  on(actions.load, (state: State): State => ({
    ...state,
    loaded: false,
    loading: true
  })),
  on(actions.received, (state: State): State => ({
    ...state,
    error: null,
    loaded: true,
    loading: false,
    receivedTime: luxon.DateTime.now().toISO()
  })),
  on(actions.reset, (state: State): State => ({
    ...state,
    data: [],
    error: null,
    loaded: false,
    loading: false
  })),
  on(actions.error, (state: State, { messageText }): State => ({
    ...state,
    error: messageText,
    loaded: false,
    loading: false
  })),
)}
);
